import { Component } from "react"
import PropTypes from "prop-types"
import { get } from "lodash"
import classNames from "classnames"
import { StarRounded, Link } from "@mui/icons-material"
import { TableRow, TableCell } from "@mui/material"
import Tooltip from "components/material/tooltip"
import { percentageFormatter } from "helpers/formatters/numbers"
import { getDriftType } from "helpers/drift"
import Drift from "components/drift/drift"
import { getFactorDisabled } from "helpers/factors"

class DetailRow extends Component {
  onClick = () => {
    const { value, openFactorProfile } = this.props
    openFactorProfile(value.id)
  }

  render() {
    const { value, index } = this.props

    return <TableRow className={classNames("detail-row", { favorite: value.favorite })}>
      <TableCell className="name" component="th" scope="row" style={index === 0 ? { color: value.color, textTransform: "uppercase" } : undefined}>
        <div className="factor-link-wrapper">
          <StarRounded className="star-icon" />
          {value.type === "factors" && !getFactorDisabled(value.category)
            ? <a onClick={this.onClick}>{value.label}{!!value.secondaryLabel && <span className="secondary"> - {value.secondaryLabel}</span>}<Link className="icon" /></a>
            : <span>{value.label}{!!value.secondaryLabel && <span className="secondary">&nbsp;- {value.secondaryLabel}</span>}</span>}
        </div>
      </TableCell>
      <TableCell align="right" style={index === 0 ? { color: value.color } : undefined}>
        <Tooltip classes={{ popper: "security-profile-drift", tooltip: "drift-tooltip" }} title={`Risk drift for ${value.label} is ${get(getDriftType(value.drift), "label")}`}>
          <div className="factor-value-wrapper">
            <Drift drift={value.drift} />
            {percentageFormatter(value.value)}
          </div>
        </Tooltip>
      </TableCell>
    </TableRow>
  }
}

DetailRow.propTypes = {
  value: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
}

export default DetailRow
